import { gql } from "@apollo/client";

export default gql`
  mutation changeBotRecordingStatusNewPageMutation(
    $meetingId: Int!
    $isRecording: Boolean!
  ) {
    changeBotRecordingStatus(meetingId: $meetingId, isRecording: $isRecording) {
      meeting {
        id
      }
    }
  }
`;
